// Возвращает заголовки авторизации для запросов к API
// Если есть fallback JWT в localStorage — добавляет Authorization: Bearer
export function getAuthHeaders(extra = {}) {
  const headers = {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
    ...extra
  };
  const fallbackToken = localStorage.getItem('fallback_access_token');
  if (fallbackToken) {
    headers['Authorization'] = `Bearer ${fallbackToken}`;
  }
  return headers;
}
